/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Observable } from 'rxjs';
import { DataSource } from 'ng2-smart-table/lib/lib/data-source/data-source';
import { Settings } from './settings';

export interface User {
  id: number;
  role: string;
  firstName: string;
  lastName: string;
  email: string;
  age: number;
  login: string;
  picture: string;
  address: Address;
  settings: Settings;
  tenantId: string;
  branchId: string;
  isSuperUser:string;
  userType?:string;
  empId?:any;
  phyId?:any;
  loginUserType?:string; 
  userFlag?:string;
  landingPageUrl?:string;
  passwordResetFlag?:boolean;
  passwordResetDate?:Date;
  discReqMethod?:'Automatic' | 'Manual'
  userJson?:string;
  sessionTimeOut?:number;
  IsDeviceFlag?:boolean;
  dashboardId?:string;
  userMoniterId?:number
}
export interface UserTypeOptions {
  value: number;
  type: string;
}

export const UserTypeValue = {
  ADMIN: 'Admin',
  EMPLOYEE: 'Employee',
  PHYSICIAN: 'Physician'
};

export const ActionDescription = {
  CREATE: 'Created',
  UPDATE: 'Updated',
  DEACTIVATE: 'Deactivated',
  ACTIVATE: 'Activated',

};
export interface Address {
  street: string;
  city: string;
  zipCode: string;
}

export abstract class UserData {
  abstract get gridDataSource(): DataSource;
  abstract getCurrentUser(): Observable<User>;
  abstract list(pageNumber: number, pageSize: number): Observable<User[]>;
  abstract get(id: number): Observable<User>;
  abstract update(user: User): Observable<User>;
  abstract updateCurrent(user: User): Observable<User>;
  abstract create(user: any): Observable<User>;
  abstract userCreate(url: string,data: any): Observable<User>;
  abstract delete(id: number): Observable<boolean>;
  abstract userList(url: string): Observable<User[]>;
  //abstract getCurrentTenantId(): Observable<User>;

  //New
  abstract getBranchList(url: string): Observable<any[]>;
 
}
